class PaymentErrorMessage {

    constructor(container, stateName) {
        this.container = container;
        this.stateName = stateName;
    }

    showMessage(state) {
        const errorMessage = localizedTexts['dev'][this.stateName][state];
        $('#'  + this.container + '-error-message-container').text(errorMessage);

        $('.form-error-message').show();
    }

}